import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=10067dcc&scoped=true&"
import script from "./Assets.vue?vue&type=script&lang=ts&"
export * from "./Assets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10067dcc",
  null
  
)

export default component.exports